// extracted by mini-css-extract-plugin
export default {"nav_container":"Geo_nav_container__SBdYK","coordinates_list":"Geo_coordinates_list__tJi-v"};